import linkedinIcon from "../assets/img/icon/linkedin.png";
import maltIcon from "../assets/img/icon/malt.jpg";
import githubIcon from "../assets/img/icon/github.png";

const socialData = [
    {
        title: "LinkedIn",
        link: "https://www.linkedin.com/in/th%C3%A9o-gu%C3%A9n%C3%A9zan-6bb5b2253/",
        image: linkedinIcon,
        path: "linkedin",
    },
    {
        title: "Malt",
        link: "https://www.malt.fr/profile/theoguenezan",
        image: maltIcon,
        path: "malt",
    },
    {
        title: "GitHub",
        link: "https://github.com/Krozac",
        image: githubIcon,
        path: "github",
    },
];

export default socialData;
